// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "X_c3";
export var authorInfoContainer = "X_c4";
export var authorInfoDetails = "X_c5";
export var authorInfoSection = "X_c6";
export var authorSocialLinks = "X_c8";
export var authorTooltipContainer = "X_c9";
export var authorTooltipContent = "X_c2";
export var authorTooltipLink = "X_c7";
export var authorTooltipZIndex = "X_db";